import * as Types from '../graphql.generated';

export type Analytics_Taxonomy_FragmentFragment = {
    __typename?: 'AnalyticsTaxonomy';
} & Pick<
    Types.AnalyticsTaxonomy,
    | 'url'
    | 'areaName'
    | 'activity'
    | 'brand'
    | 'countryCode'
    | 'countyAreaName'
    | 'currencyCode'
    | 'listingsCategory'
    | 'outcode'
    | 'outcodes'
    | 'page'
    | 'postalArea'
    | 'radius'
    | 'radiusAutoexpansion'
    | 'regionName'
    | 'resultsSort'
    | 'searchGuid'
    | 'searchIdentifier'
    | 'section'
    | 'searchLocation'
    | 'viewType'
    | 'searchResultsCount'
    | 'expandedResultsCount'
    | 'totalResults'
    | 'emailAllFormShown'
    | 'emailAllTotalAgents'
    | 'bedsMax'
    | 'bedsMin'
    | 'priceMax'
    | 'priceMin'
    | 'location'
    | 'propertyType'
    | 'geoIdentifier'
>;

export const Analytics_Taxonomy_FragmentFragmentDoc = `
    fragment ANALYTICS_TAXONOMY_FRAGMENT on AnalyticsTaxonomy {
  url
  areaName
  activity
  brand
  countryCode
  countyAreaName
  currencyCode
  listingsCategory
  outcode
  outcodes
  page
  postalArea
  radius
  radiusAutoexpansion
  regionName
  resultsSort
  searchGuid
  searchIdentifier
  section
  searchLocation
  viewType
  searchResultsCount
  expandedResultsCount
  totalResults
  emailAllFormShown
  emailAllTotalAgents
  bedsMax
  bedsMin
  priceMax
  priceMin
  location
  propertyType
  geoIdentifier
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {};
}
export type Sdk = ReturnType<typeof getSdk>;
